export default function getStickyMenuAnchor(componentName: string, sitecoreContext: any): string {
  const anchorValue =
    sitecoreContext.route.placeholders['jss-main']?.find(
      (item: any) => item.componentName === componentName && item.fields?.['Sticky Menu Title']?.value
    )?.fields['Sticky Menu Title'].value ?? '';

  return anchorValue;
}
